import $ from 'jquery'

export function messageBox(title, message, actions, keyboard = true) {
  return new Promise((resolve, reject) => {
    let div = document.createElement('div')
    let buttons = ''
    let index = 0
    for (let id in actions) {
      if (actions.hasOwnProperty(id)) {
        buttons += `<button id="dialogbox_action_${id}" data-action="${id}" type="button" class="${'btn ' + (index === 0 ? 'btn-primary' : 'btn-secondary')}">
  ${actions[id]}
</button>`
      }
      index++
    }
    div.innerHTML = `<div class="modal outer" tabindex="-1" role="dialog" id="dialogbox">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">${title}</h2>
          </div>
          <div class="modal-body">
            <p>${message}</p>
          </div>
          <div class="modal-footer">
            ${buttons}
          </div>
        </div>
      </div>
    </div>`
    document.querySelector('body').appendChild(div)
    let $dialogBox = $('#dialogbox')
    $dialogBox.on('hidden.bs.modal', e => {
      $dialogBox.parent().remove()
    })
    $dialogBox.find('button[data-action]').click(ev => {
      $dialogBox.modal('hide')
      resolve(ev.target.getAttribute('data-action'))
    })
    $dialogBox.modal({backdrop: 'static', show: true, keyboard: keyboard})
  })
}
